var map = {
	"./Internship.pdf": 701,
	"./banner1.png": 7892,
	"./banner2.png": 4751,
	"./banner3.png": 1462,
	"./factshlogo.jpeg": 1418,
	"./iiitkottayam1.png": 4671,
	"./iiitkottayam2.jpg": 3056,
	"./iiitkottayam3.jpg": 3981,
	"./lab1.png": 6477,
	"./lab2.png": 5270,
	"./map-placeholder.png": 3945,
	"./new.gif": 8478,
	"./publishedpaper.pdf": 6639,
	"./slider_img1.jpeg": 5632,
	"./slider_img2.jpeg": 8049,
	"./slider_img3.jpeg": 2778,
	"./slider_img4.jpeg": 5611,
	"./slider_img5.jpeg": 6756,
	"./slider_img6.jpeg": 6613,
	"./slider_img7.jpeg": 5230,
	"./slider_img8.jpg": 5602,
	"./visit1.jpeg": 7422,
	"./visit2.png": 2634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;